import React from 'react';
import PropTypes from 'prop-types';
import './MarketplacePopup.css';
import MarketPlaceSvg from '../project.svg';
import { Button } from '../../Button';

export const MarketplacePopup = ({
  handleTalkToRepresentative,
  handleContinueFilling,
}) => (
  <div className="marketplace-content">
    <div className="marketplace-content__image-container">
      <img
        alt="Managed"
        className="marketplace-content__image-container__image"
        src={MarketPlaceSvg}
      />
    </div>
    <div className="marketplace-content__body">
      <div className="marketplace-content__body__title">
        Your project is currently on track for
        <br />
        our Marketplace service
      </div>
      <div className="marketplace-content__body__description">
        Thanks for the info so far! Your project still qualifies to use our
        <br />
        Marketplace! You&apos;re almost ready to checkout, we have a few more
        <br />
        questions to ask before you get to choose your video creator.
        <br />
        <br />
        Tired of answering questions? Let us manage the project for you and
        <br />
        talk to a representative today!
      </div>
    </div>
    <div className="marketplace-content__action">
      <Button
        id="marketplace-represent-button"
        className="marketplace-content__action--contact"
        onClick={handleTalkToRepresentative}
        rounded
        block
        title="talk to a representative"
      />
      <Button
        id="marketplace-continue-button"
        textClassName="marketplace-content__action--continue"
        onClick={handleContinueFilling}
        transparent
        block
        withoutTextTransform
        title="Continue filing our brief"
      />
    </div>
  </div>
);

MarketplacePopup.propTypes = {
  handleTalkToRepresentative: PropTypes.func,
  handleContinueFilling: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Popup/MarketplacePopup/MarketplacePopup.js